import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const RANGES = [
  ["today", "Oggi"],
  ["last7", "Ultimi 7 giorni"],
  ["last30", "Ultimi 30 giorni"],
  ["all", "Sempre"],
];

export default function StatsPanel() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setErr(true));
  }, []);

  if (err) return <p className="adm-empty">Impossibile caricare le statistiche.</p>;
  if (!stats) return <p className="adm-empty">Caricamento statistiche…</p>;

  const maxTop = Math.max(1, ...stats.top_pages.map((p) => p.count));
  const chartData = stats.daily.map((d) => ({
    ...d,
    label: new Date(d.date).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }),
  }));

  return (
    <div data-testid="stats-panel">
      <div className="stats-kpis">
        {RANGES.map(([k, l]) => (
          <div className="stats-kpi" key={k} data-testid={`stats-kpi-${k}`}>
            <span className="stats-kpi-label">{l}</span>
            <span className="stats-kpi-visits" data-testid={`stats-visits-${k}`}>{stats.totals[k].visits}</span>
            <span className="stats-kpi-sub">visite</span>
            <span className="stats-kpi-visitors" data-testid={`stats-visitors-${k}`}>{stats.totals[k].visitors} visitatori unici</span>
          </div>
        ))}
      </div>

      <div className="adm-card">
        <h3>Visite giornaliere (ultimi 30 giorni)</h3>
        <div style={{ width: "100%", height: 300, minWidth: 0 }} data-testid="stats-chart">
          <ResponsiveContainer width="100%" height="100%" minHeight={300}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: -18, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e6e8f0" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#565a75" }} interval={4} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#565a75" }} axisLine={false} tickLine={false} />
              <Tooltip
                cursor={{ fill: "rgba(59,86,214,.08)" }}
                contentStyle={{ borderRadius: 10, border: "1px solid #e6e8f0", fontSize: 13 }}
                labelFormatter={(l) => `Giorno ${l}`}
                formatter={(v, n) => [v, n === "visits" ? "Visite" : "Visitatori"]}
              />
              <Bar dataKey="visits" fill="#3b56d6" radius={[4, 4, 0, 0]} maxBarSize={26} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="adm-card">
        <h3>Pagine più viste</h3>
        {stats.top_pages.length === 0 ? (
          <p className="adm-empty">Ancora nessuna visita registrata.</p>
        ) : (
          <div className="stats-pages" data-testid="stats-top-pages">
            {stats.top_pages.map((p) => (
              <div className="stats-page-row" key={p.path}>
                <span className="stats-page-name">{p.name}</span>
                <div className="stats-page-bar-wrap">
                  <div className="stats-page-bar" style={{ width: `${(p.count / maxTop) * 100}%` }} />
                </div>
                <span className="stats-page-count">{p.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
